export default {
  name: 'usIndexmaterialContent',
  props: {
    googleplayUrl: {
      default: 'https://play.google.com/store/apps/details?id=com.aaalive.live&hl=en',
      type: String
    }
  },
  components: {},
  data: function data() {
    return {};
  },
  methods: {}
};